function s(s,a){return s.classList?!!a&&s.classList.contains(a):-1!==(" "+(s.className.baseVal||s.className)+" ").indexOf(" "+a+" ")}export{s as default};
//# sourceMappingURL=hasClass.js.map
